import React from "react";

import { Grid, Checkbox, FormControlLabel, Typography } from "@tiny/components";
import { TagItemProps } from "./TagItem.types";
import { useStyles } from "./TagItem.styles";

function TagItem(props: TagItemProps) {
  const { checked, onChange, label, tag } = props;

  const classes = useStyles();

  return (
    <Grid item xs={12} md={6}>
      <FormControlLabel
        control={
          <Checkbox
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChange(event.target.checked, tag!)
            }
            color="primary"
            checked={checked}
            className={classes.checkbox}
          />
        }
        label={
          <Typography variant="body2" color="grey" tone={900}>
            {label}
          </Typography>
        }
      />
    </Grid>
  );
}

export default React.memo(TagItem);
